<template>
  <NichesContent />
</template>

<script>
import { mapGetters } from 'vuex';

import NichesContent from '@/components/Niches/NichesContent';

export default {
  nuxtI18n: {
    paths: {
      en: '/niches/:slug/:page',
      de: '/nischen/:slug/:page',
      es: '/nichos/:slug/:page',
      pt: '/nichos/:slug/:page'
    }
  },
  components: {
    NichesContent
  },
  async validate({ params, store }) {
    const currentPage = params.page ? parseInt(params.page) : 1;

    store.dispatch('niches/CLEAN_NICHES');
    await Promise.all([
      store.dispatch('niches/LOAD_NICHE', { slug: params.slug }),
      store.dispatch('niches/LOAD_NICHE_CONTENT', {
        slug: params.slug,
        page: currentPage
      })
    ]);
    return store.state.niches.nicheContent.length;
  },
  async asyncData({ store, app }) {
    const { en, de, es, pt, cannonical } = store.state.niches.niche.metadata;
    const slugs = {
      en: app.localePath({ name: 'niches-slug', params: { slug: en } }, 'en'),
      de: app.localePath({ name: 'niches-slug', params: { slug: de } }, 'de'),
      es: app.localePath({ name: 'niches-slug', params: { slug: es } }, 'es'),
      pt: app.localePath({ name: 'niches-slug', params: { slug: pt } }, 'pt')
    };

    const canonical = app.$canonicalPlugin(
      slugs[`${store.$i18n.locale}`],
      store.$i18n.locale,
      true,
      cannonical
    );

    return {
      seoFields: { canonical }
    };
  },
  head() {
    const metadata = this.$store.state.niches.niche.metadata;
    const i18nSeo = this.$seoPlugin({ hreflang: false, canonical: false });

    const openGraph = this.$openGraphPlugin(
      metadata?.metaTitle,
      'website',
      this.$route.path,
      metadata?.metaDescription,
      this.getImageFirstResult,
      this.$store.state.i18n.locale
    );

    return {
      title: metadata?.metaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: metadata?.metaDescription
        },
        { hid: 'robots', name: 'robots', content: 'noindex, follow' },
        ...openGraph
      ],
      link: [this.seoFields.canonical, ...i18nSeo.link]
    };
  },
  computed: {
    ...mapGetters('niches', ['getImageFirstResult'])
  }
};
</script>
